"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toBeEmptyDOMElement = toBeEmptyDOMElement;

var _utils = require("./utils");

function toBeEmptyDOMElement(element) {
  var _this = this;

  (0, _utils.checkHtmlElement)(element, toBeEmptyDOMElement, this);
  return {
    pass: isEmptyElement(element),
    message: function message() {
      return [_this.utils.matcherHint("".concat(_this.isNot ? '.not' : '', ".toBeEmptyDOMElement"), 'element', ''), '', 'Received:', "  ".concat(_this.utils.printReceived(element.innerHTML))].join('\n');
    }
  };
}
/**
 * Identifies if an element doesn't contain child nodes (excluding comments)
 * ℹ Node.COMMENT_NODE can't be used because of the following issue 
 * https://github.com/jsdom/jsdom/issues/2220
 *
 * @param {*} element an HtmlElement or SVGElement
 * @return {*} true if the element only contains comments or none
 */


function isEmptyElement(element) {
  var nonCommentChildNodes = _toConsumableArray(element.childNodes).filter(function (node) {
    return node.nodeType !== 8;
  });

  return nonCommentChildNodes.length === 0;
}